import { useTranslation } from '@frontend/i18n';
import { StaticVerticalStepper, StaticVerticalStepperContent } from '@frontend/static-vertical-stepper';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { useInsuranceContext } from '../providers/insurance-provider';
import { UndefinedOrNull } from '../utils/types';
import { StyledCardContainer } from './styled-card-container';

export const History = () => {
  const { t } = useTranslation();
  const { insuranceDetails } = useInsuranceContext();

  const stepsData: UndefinedOrNull<StaticVerticalStepperContent[]> = insuranceDetails?.historyData;
  const hasHistoryData = stepsData && Object.keys(stepsData).length > 0;

  if (!hasHistoryData) return null;

  return (
    <StyledCardContainer>
      <section css={{ padding: theme.spacing(2, 2, 1, 2) }}>
        <Heading level={3} css={{ marginBottom: theme.spacing(3) }}>
          {t('History')}
        </Heading>
        <StaticVerticalStepper stepsInfo={stepsData} />
      </section>
    </StyledCardContainer>
  );
};
History.displayName = 'History';
